<script setup lang="ts">
  import { cva } from 'class-variance-authority'

  const props = defineProps<{
    size: 'small' | 'medium' | 'large'
    content: any
  }>()

  const rows = computed(() => {
    const blocks = props.content.filter((block: any) => block?.content?.component)

    if (props.size === 'large') {
      return blocks.map((block: any, index: number) => ({
        ...block,
        content: {
          ...block.content,
          component: `${block.content.component}-${props.size}`
        },
        compact: false,
        even: index % 2 !== 0
      }))
    }

    const singleItems = blocks.length % 3
    const lastRowItemIndex = blocks.length - 1 - singleItems

    return blocks.map((block: any, index: number) => ({
      ...block,
      content: {
        ...block.content,
        component: `${block.content.component}-${props.size}`
      },
      compact: index <= lastRowItemIndex
    }))
  })

  const base = computed(() =>
    cva('grid gap-8 grid-cols-1', {
      variants: {
        size: {
          small: 'md:grid-cols-3',
          large: 'md:gap-20',
          medium: 'md:grid-cols-3'
        }
      }
    })({
      size: props.size
    })
  )
</script>
<template>
  <div :class="base">
    <StoryblokComponent
      v-for="item in rows"
      :key="item._uid"
      :blok="item.content"
      :size="size"
      :compact="item.compact"
      :even="item.even"
    />
  </div>
</template>
